"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextPrevious = void 0;
var react_1 = __importStar(require("react"));
var buttons_1 = require("../buttons");
var classnames_1 = __importDefault(require("classnames"));
var NextPrevious = function (props) {
    var errors = (0, react_1.useMemo)(function () {
        if (typeof props.errors == 'object') {
            return Object.keys(props.errors).length > 0;
        }
        else {
            return props.errors ? true : false;
        }
    }, [props.errors]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('row', props.className) },
        react_1.default.createElement("div", { className: "col-3" }, props.previous === null ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement(buttons_1.Button, { className: "float-left", label: props.previous || 'Previous', disabled: props.onPrevious ? undefined : true, onClick: function () {
                props.onPrevious && props.onPrevious();
            } }))),
        react_1.default.createElement("div", { className: "col-6 text-center text-danger" }, errors && (react_1.default.createElement("div", { id: "next-hint", className: "ml-2" },
            react_1.default.createElement("i", { className: "fas fa-exclamation-triangle" }),
            " Please complete the required fields"))),
        react_1.default.createElement("div", { className: "col-3" }, props.next === null ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement(buttons_1.Button, { id: "next-summary", label: props.next || 'Next', disabled: props.onNext ? undefined : true, onClick: function () {
                props.onNext && props.onNext();
            }, className: "float-right", describedBy: errors ? 'next-hint' : '' })))));
};
exports.NextPrevious = NextPrevious;
//# sourceMappingURL=NextPrevious.js.map